import { PATTERN_SEARCH_REQUEST, PATTERN_SEARCH_SUCCESS, PATTERN_SEARCH_ERROR } from "../actions/patternSearch"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const patternSearch = (state = initialState, action) => {
    switch (action.type) {
        case PATTERN_SEARCH_REQUEST:
            return {
                ...state,
                loading: true
            }

        case PATTERN_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case PATTERN_SEARCH_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}

export default patternSearch
